import { support } from "@@/shared/support";

const swishErrorText = (swishErrorCode: string) => {
    switch (swishErrorCode) {
        case "AM04":
            return "Saknas tillräckligt med pengar på det anslutna kontot";
        case "RP06":
            return "Finns redan en aktiv betalning för detta nummer";
        case "RF07":
            return "Betalning nekad";
        case "TM01":
            return "Betalning i swish tog för lång tid";
        case "BANKIDCL":
            return "BankID autentisering misslyckad";
        case "ACMT03":
        case "ACMT07":
            return "Telefonnumret saknar swish abonnemang";
        default:
    }
    return `Problem med uppkoppling mot Swish, pröva igen senare eller kontakta ${support.towni.supportEmail} om felet kvarstår`;
};

export { swishErrorText };
